<app-loading-screen *ngIf="showSpinner">Loading Validation Summary</app-loading-screen>